import React from "react";
import { formatPercent } from "app/formatting/functions";
import { DescriptionListEntry } from "app/layout/components";
import { Country } from "app/shares/interfaces";
import { DescriptionListColumnTable } from "app/layout/DescriptionList/DescriptionList";

/**
 * Renders a list of Company Detail Props
 */
interface CompanyProps {
    wkn: string;
    country?: Country;
    industry?: string;
    equityType: string;
    /** Free Float = Streubesitz */
    freeFloat?: number | null;
}

const resolveShareType = (type: string): string => {
    switch (type) {
        case "REGISTERED":
            return "Namensaktie";
        case "PREFERRED":
            return "Vorzugsaktie";
        case "ORDINARY":
            return "Stammaktie";
        default:
            return "-";
    }
};

export const CompanyProps = ({ wkn, country, industry, equityType, freeFloat }: CompanyProps) => (
    <DescriptionListColumnTable>
        <DescriptionListEntry
            key={0}
            term="Land"
            details={country === undefined || country.name === "" ? "-" : country.name}
        />
        <DescriptionListEntry
            key={1}
            term="Branche"
            details={industry === undefined || industry === "" ? "-" : industry}
        />
        <DescriptionListEntry key={2} term="WKN" details={wkn === undefined || wkn === "" ? "-" : wkn} />
        <DescriptionListEntry key={3} term="Typ" details={resolveShareType(equityType)} />
        <DescriptionListEntry
            key={4}
            term="Streubesitz"
            details={freeFloat === undefined || freeFloat === null ? "-" : formatPercent(freeFloat)}
        />
    </DescriptionListColumnTable>
);
